import refs  from './refs.js';
import { onFooterSubmit } from './handlers.js';

refs.footerForm.addEventListener('submit', onFooterSubmit);

